/* global $ window */

import LayoutVariables from '../../../javascript/src/config/layout_variables'
import Events from '../../../javascript/src/config/events'
import registerOutsideClickListener from '$lib/outside_event_listener'
import { hideNavBackdrop, showNavBackdrop } from '$lib/navigation_backdrop_helper'

require('stickUp')

export default class NavigationWidget {
  get navigationNs() {
    return '.navigation'
  }

  get navigationToggle() {
    return '.js-toggle-navigation'
  }

  get navigationActiveClass() {
    return 'navigation-links-container--open'
  }

  get searchToggle() {
    return '.navigation-search-bar'
  }

  get navigationMainLink() {
    return '.navigation__main-link'
  }

  get navigationItem() {
    return '.navigation__item'
  }

  get navigationFixedSelector() {
    return '.js-navigation-fixed'
  }

  get navigationItemActiveClass() {
    return 'navigation__item--active'
  }

  get toggleWarningButton() {
    return '.js-toggle-warning'
  }

  get warningContainer() {
    return '.js-unauthorized-content-warning-container'
  }

  get navigationSubMenu() {
    return '.js-navigation-links-container'
  }

  get openRegisterModal() {
    return '.js-open_register_modal'
  }

  get bodyElement() {
    return 'body'
  }

  get htmlElement() {
    return 'html'
  }

  constructor() {
    this.$ns = $(this.navigationNs)
    this.$navLinks = $(this.navigationSubMenu)
    this.$window = $(window)
    this.$mainWrapper = $('.l-wrapper')
    this.$toggleWarningButton = $(this.toggleWarningButton)
    this.$warningContainer = $(this.warningContainer)
    this.$searchToggle = $(this.searchToggle)
    this.$html = $(this.htmlElement)
    this.$body = $(this.bodyElement)

    this.initBehavior()
  }

  initBehavior() {
    this.toggleWarning()

    $(this.openRegisterModal).on('click', this.onRegisterClick.bind(this))

    this.$ns
      .find(this.navigationItem)
      .on('click', this.navigationMainLink, this.onOpenSubmenu.bind(this))

    this.$ns.find(this.navigationToggle).on('click', () => {
      if (this.$navLinks.hasClass(this.navigationActiveClass)) {
        this.hideNavigation()
      } else {
        this.showNavigation()
      }
    })

    $(this.navigationFixedSelector).stickUp()
  }

  onRegisterClick() {
    this.hideNavigation()
  }

  hideNavigation() {
    hideNavBackdrop()

    this.$searchToggle.css('z-index', 5)
    this.$navLinks.removeClass(this.navigationActiveClass)
    this.allowScroll()
  }

  showNavigation() {
    showNavBackdrop()

    this.$ns.trigger(Events.ON_NAVIGATION_OPEN)
    this.$searchToggle.css('z-index', 3)
    this.$navLinks.addClass(this.navigationActiveClass)
    this.blockScroll()

    registerOutsideClickListener(this.navigationSubMenu, () => {
      this.hideNavigation()
    })
  }

  onOpenSubmenu(event) {
    const width = this.$window.width()
    const currentLink = $(event.currentTarget)

    if (width < LayoutVariables.desktopWidth) {
      event.preventDefault()
      const parentItem = currentLink.parents(this.navigationItem)

      parentItem.toggleClass(this.navigationItemActiveClass)
    }
  }

  toggleWarning() {
    this.$toggleWarningButton.on('click', () => {
      const width = this.$window.width()
      if (width >= LayoutVariables.tabletWidth && width < LayoutVariables.desktopWidth) {
        this.$warningContainer.toggleClass('navigation__unauthorized-container--active')
      }
    })
  }

  blockScroll() {
    this.$html.css('overflow', 'hidden')
  }

  allowScroll() {
    this.$html.css('overflow', 'scroll')
  }
}
